import React from "react";
import "../App.css";
import "../utils/styles/PageAnimations.css";

function ImprintPage() {
  return (
    <div
      className="imprint-page page-animated"
      style={{
        padding: "5rem 2rem",
        maxWidth: "1100px",
        margin: "0 auto",
      }}
    >
      <h1
        className="animate-up delay-1"
        style={{
          textAlign: "center",
          marginBottom: "4rem",
          fontSize: "3rem",
          color: "#1d2b45",
        }}
      >
        Impressum
      </h1>

      <div
        className="animate-up delay-2 hover-card"
        style={{
          background: "rgba(255,255,255,0.92)",
          borderRadius: "28px",
          padding: "3rem",
          boxShadow: "0 10px 30px rgba(31,152,244,0.08)",
          border: "1px solid rgba(3,122,246,0.08)",
          backdropFilter: "blur(10px)",
        }}
      >
        <div
          style={{
            display: "grid",
            gap: "1.5rem",
          }}
        >
          <div
            className="hover-card"
            style={{
              padding: "1.4rem",
              borderRadius: "18px",
              background: "#f7fbff",
              border: "1px solid rgba(3,122,246,0.08)",
            }}
          >
            <h2
              style={{
                marginBottom: "1rem",
                color: "#037af6",
                fontSize: "1.5rem",
              }}
            >
              🏢 Unternehmen
            </h2>

            <p style={{ lineHeight: "1.9", color: "#42526b" }}>
              <strong>Onenizer GmbH</strong>
              <br />
              Startup-Straße 1
              <br />
              12345 Innovation City
              <br />
              Deutschland
            </p>
          </div>

          <div
            className="hover-card"
            style={{
              padding: "1.4rem",
              borderRadius: "18px",
              background: "#f7fbff",
              border: "1px solid rgba(3,122,246,0.08)",
            }}
          >
            <h2
              style={{
                marginBottom: "1rem",
                color: "#037af6",
                fontSize: "1.5rem",
              }}
            >
              📬 Kontakt
            </h2>

            <div
              style={{
                display: "grid",
                gap: "0.8rem",
                color: "#42526b",
                lineHeight: "1.8",
              }}
            >
              <p>
                <strong>Email:</strong> info@onenizer.com
              </p>

              <p>
                <strong>Telefon:</strong> +49 (0)123 456 7890
              </p>

              <p>
                <strong>Website:</strong> www.onenizer.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImprintPage;
